import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const Auth = lazy(() => import("../components/Authentication/Auth.jsx"));
const AuthLogin = lazy(() => import("../components/Authentication/AuthLogin/AuthLogin"));
const ForgotPassword = lazy(() => import("../components/Authentication/ForgotPassword/ForgotPassword.jsx"));
const Register = lazy(() => import("../components/Authentication/Register/Register.jsx"));
const Error403 = lazy(() => import("../pages/Errors/Error403.jsx"));
const Error404 = lazy(() => import("../pages/Errors/Error404.jsx"));
const Error500 = lazy(() => import("../pages/Errors/Error500.jsx"));
const RestrictedPage = lazy(() => import("../pages/CustomerPages/AccessDenied"));

export default [
  {
    path: ROUTES.ROOT,
    element: <LazyRoute><Auth /></LazyRoute>,
    children: [
      { index: true, element: <LazyRoute><AuthLogin /></LazyRoute> },
      { path: ROUTES.AUTH.LOGIN, element: <LazyRoute><AuthLogin /></LazyRoute> },
      { path: ROUTES.AUTH.FORGOT_PASSWORD, element: <LazyRoute><ForgotPassword /></LazyRoute> },
      { path: ROUTES.AUTH.REGISTER, element: <LazyRoute><Register /></LazyRoute> },
      { path: ROUTES.ERRORS._403, element: <LazyRoute><Error403 /></LazyRoute> },
      { path: ROUTES.ERRORS._404, element: <LazyRoute><Error404 /></LazyRoute> },
      { path: ROUTES.ERRORS._500, element: <LazyRoute><Error500 /></LazyRoute> },
      { path: ROUTES.ERRORS.DENIED, element: <LazyRoute><RestrictedPage /></LazyRoute> },
    ],
  },
];
